// src/components/LoadingIndicator.tsx
import React from 'react';

const LoadingIndicator: React.FC = () => {
    return <div>Loading...</div>; // Customize as needed
};

export default LoadingIndicator;
